var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 17,
    viewBox: "0 0 18 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.7071 2.70711L17.4142 2L16 0.585786L15.2929 1.29289L16.7071 2.70711ZM9 9L8.29289 8.29289C7.90237 8.68342 7.90237 9.31658 8.29289 9.70711L9 9ZM15.2929 16.7071C15.6834 17.0976 16.3166 17.0976 16.7071 16.7071C17.0976 16.3166 17.0976 15.6834 16.7071 15.2929L15.2929 16.7071ZM15.2929 1.29289L8.29289 8.29289L9.70711 9.70711L16.7071 2.70711L15.2929 1.29289ZM8.29289 9.70711L15.2929 16.7071L16.7071 15.2929L9.70711 8.29289L8.29289 9.70711Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.29289 2.70711L0.585787 2L2 0.585786L2.70711 1.29289L1.29289 2.70711ZM9 9L9.70711 8.29289C10.0976 8.68342 10.0976 9.31658 9.70711 9.70711L9 9ZM2.70711 16.7071C2.31658 17.0976 1.68342 17.0976 1.29289 16.7071C0.902369 16.3166 0.902369 15.6834 1.29289 15.2929L2.70711 16.7071ZM2.70711 1.29289L9.70711 8.29289L8.29289 9.70711L1.29289 2.70711L2.70711 1.29289ZM9.70711 9.70711L2.70711 16.7071L1.29289 15.2929L8.29289 8.29289L9.70711 9.70711Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.0af1786bfb7f25ded71fcb411170f0e1.svg";
export { ForwardRef as ReactComponent };